
import { contactMessages } from '@/integrations/supabase/client';
import { supabase } from '@/integrations/supabase/client';

interface EmailProps {
  to: string;
  subject: string;
  html: string;
  from?: string;
  text?: string;
}

/**
 * Service for handling email-related functionality
 */
class EmailService {
  /**
   * Send an email using Supabase Edge Function
   */
  async sendEmail(data: EmailProps): Promise<any> {
    try {
      const { data: result, error } = await supabase.functions.invoke('send-email', {
        body: data,
      });
      
      if (error) {
        throw error;
      }
      
      return result;
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  }
  
  /**
   * Send a response to a contact message
   */
  async sendContactResponse(messageId: string, responseText: string): Promise<any> {
    try {
      // Fetch the contact message to get the email address
      const { data: message, error: fetchError } = await contactMessages()
        .select('*')
        .eq('id', messageId)
        .single();
        
      if (fetchError) throw fetchError;
      
      if (!message) {
        throw new Error('Contact message not found');
      }
      
      // Send the email
      await this.sendEmail({
        to: message.email,
        subject: 'Response to your inquiry',
        html: `
          <h2>Hello ${message.first_name} ${message.last_name},</h2>
          <p>Thank you for reaching out to us. Here's our response to your inquiry:</p>
          <div style="padding: 15px; background-color: #f7f7f7; border-left: 4px solid #6b46c1; margin: 20px 0;">
            ${responseText.replace(/\n/g, '<br>')}
          </div>
          <p>If you have any further questions, please don't hesitate to contact us.</p>
          <p>Best regards,<br>The HumbleMind AI Team</p>
        `
      });
      
      // Update the contact message with the response and mark as responded
      const { error: updateError } = await contactMessages()
        .update({
          admin_response: responseText,
          response_sent_at: new Date().toISOString(),
          status: 'responded'
        })
        .eq('id', messageId);
        
      if (updateError) throw updateError;
      
      return { success: true };
    } catch (error) {
      console.error('Error sending contact response:', error);
      throw error;
    }
  }
}

export default new EmailService();
